export default __webpack_public_path__ + "static/media/hourglass.9a0b3113.png";